<template>
  <div name="demo-pdf-report-html">
  	pdf report html
  </div>
</template>

<script>
export default {
  name: 'demo-pdf-report-html'
}
</script>


// WEBPACK FOOTER //
// demoPdfReportHtml.vue?67126c0d